enum ANCHOR {
	HOME = '/',
}

export default ANCHOR;
